<div class="modal-body">
    <div class="modal-header-title">
        <h5 class="br-white">Confirmation</h5>
        <span class="modal-container-close" (click)="modalRef.hide();"><i class="fa fa-times-circle"
                aria-hidden="true"></i></span>
    </div>
    <div class="" style="padding: 10px 0 20px 0;">
        <div class="modal-icon-circle">
            <i class="material-icons clr-{{colorCode}}">{{icon}}</i>
        </div>
        <h5 class="modal-title br-left-none">Are You Sure !</h5>
        <h6 class="modal-sub-info br-left-none">{{textOne}} <span
                class="clr-{{colorCode}} animated fadeInDown infinite">{{textTwo}} </span> {{textThree}}</h6>
    </div>
    <div class="modal-actions">
        <button type="button" class="modal-cancel btns-modal-action fill-right-to-left pull-left"
            (click)="cancel();">No</button>
        <button type="button" class="modal-confirm btns-modal-action fill-left-to-right"
            (click)="proceed();">Yes</button>
    </div>
</div>
